export default __webpack_public_path__ + "static/garden_path-a74100e9672b82901b996a5812155405.png";